// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9528) return "css/9528-8a9695b6.css";
	// return url for filenames based on template
	return "css/" + {"1148":"external","5072":"application"}[chunkId] + "-" + {"1148":"77ac6fcb","5072":"4cae4330"}[chunkId] + ".css";
};